<template>
  <div class="list-wrap">
    <el-card class="list-body">
      <!-- 详情区域 -->
      <table class="table">
        <tr>
          <td width="20%">用户id</td>
          <td>{{detail.ac_id}}</td>
          <td width="20%">微信昵称</td>
          <td>{{detail.nickname}}</td>
        </tr>
        <tr>
          <td>微信头像</td>
          <td>
            <img :src="detail.avatar" alt class="avatar">
          </td>
          <td>姓名</td>
          <td>{{detail.name}}</td>
        </tr>
        <tr>
          <td>性别</td>
          <td>{{ detail.gender | filterGender }}</td>
          <td>手机号</td>
          <td>{{detail.mobile}}</td>
        </tr>
        <tr>
          <td>积分余额</td>
          <td>
            {{detail.score}}
            <el-button @click="showScoreLog(ac_id)" class="ml5" size="mini" type="text">积分记录</el-button>
            <el-button @click="showRemark(ac_id)" class="ml5" size="mini" type="text">修改</el-button>
          </td>
          <td>状态</td>
          <td>
            <el-switch
              :active-value="1"
              :inactive-value="2"
              @change="onChangeUserStatus"
              active-color="#13ce66"
              inactive-color="#999"
              v-model="detail.status"
            ></el-switch>
            <span class="ml5" style="vertical-align: middle;">{{detail.status==1?'正常':'停用'}}</span>
          </td>
        </tr>
        <tr>
          <td>领取积分次数</td>
          <td>{{detail.total_obtain_score_num}}</td>
          <td>累计获得积分</td>
          <td>{{detail.total_obtain_score}}</td>
        </tr>
        <tr>
          <td>核销次数</td>
          <td>{{detail.total_use_num}}</td>
          <td>累计优惠金额</td>
          <td>{{detail.total_use_money}}</td>
        </tr>
      </table>

      <!-- 宠物列表区域 -->
      <el-row class="mt20 mb5 ft16">宠物信息</el-row>
      <el-table
        :data="pet.list"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="petTable"
        ref="petTable"
        style="width: 100%"
      >
        <el-table-column label="昵称" prop="pt_name"></el-table-column>
        <el-table-column label="类别">
          <template slot-scope="scope">
            <span v-if="scope.row.pt_type == 1">狗</span>
            <span v-if="scope.row.pt_type == 2">猫</span>
            <span v-if="scope.row.pt_type == 3">水族</span>
          </template>
        </el-table-column>
        <el-table-column label="品种" prop="ptype_name"></el-table-column>
        <el-table-column label="性别" prop="pt_sex">
          <template slot-scope="scope">
            {{ scope.row.pt_sex==1?'公':'母' }}
          </template>
        </el-table-column>
        <el-table-column label="生日">
          <template slot-scope="scope">
            {{ scope.row.pt_birth | formatDate }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 查询记录区域 -->
      <el-row class="mt20 mb5 ft16">查询记录</el-row>
      <el-table
        :data="searchLog.list"
        class="page-wrap"
        header-row-class-name="table-black-header"
        key="logTable"
        max-height="400"
        ref="logTable"
        style="width: 100%"
      >
        <el-table-column label="防伪码" prop="security_code"></el-table-column>
        <el-table-column label="溯源码" prop="traceable_code">
          <template slot-scope="scope">
            <span @click="toCodeDetail(scope.row.traceable_code)" class="underline cursor">{{scope.row.traceable_code}}</span>
          </template>
        </el-table-column>
        <el-table-column label="防伪码第几次被查询" prop="num"></el-table-column>
        <el-table-column label="时间" prop="queried_at"></el-table-column>
        <el-table-column label="获得积分" prop="score"></el-table-column>
      </el-table>
      <!--页码信息-->
      <div class="ftc mt10">
        <el-pagination
          :page-size="searchLog.page.pageSize"
          :total="searchLog.page.total"
          @current-change="onChangePage"
          background
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 编辑积分 -->
    <el-dialog :visible.sync="remark.show" title="修改积分" width="500px">
      <el-form :model="remark" label-width="80px" ref="remarkForm">
        <el-form-item :rules="{required: true, message: '请填写变更积分'}" label="变更积分" prop="score">
          <el-input placeholder="输入增加的积分数（输入负数扣除）" v-model="remark.score"></el-input>
        </el-form-item>
        <el-form-item :rules="{required: true, message: '请填写操作原因'}" label="操作原因" prop="reason">
          <el-input placeholder="输入操作原因" type="textarea" v-model="remark.reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer ftc" slot="footer">
        <el-button @click="onRemark" type="primary">确认</el-button>
        <el-button @click="remark.show = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 积分记录 -->
    <el-dialog :visible.sync="scoreLog.show" title="积分变动记录" width="600px">
      <el-table
        :data="scoreLog.list"
        class="page-wrap"
        header-row-class-name="table-black-header"
        height="400"
        key="logTable"
        ref="logTable"
        style="width: 100%"
      >
        <el-table-column label="原因类型">
          <template slot-scope="scope">
            <p v-if="scope.row.reason_type==1">查询获得</p>
            <p v-else-if="scope.row.reason_type==2">兑换消费</p>
            <p v-else-if="scope.row.reason_type==3">客服修改</p>
          </template>
        </el-table-column>
        <el-table-column label="原因" prop="reason"></el-table-column>
        <el-table-column label="变动情况" prop="score" width="140">
          <template slot-scope="scope">
            <p>
              <span v-if="scope.row.change_type==1">+</span>
              <span v-else-if="scope.row.change_type==2">-</span>
              <span>{{scope.row.score}}（{{scope.row.after_score}}）</span>
            </p>
          </template>
        </el-table-column>

        <el-table-column label="时间" prop="created_at"></el-table-column>
      </el-table>
      <div class="ftc mt10">
        <el-pagination
          :page-size="scoreLog.page.pageSize"
          :total="scoreLog.page.total"
          @current-change="onChangescoreLogPage"
          background
          layout="total, prev, pager, next, jumper"
        ></el-pagination>
      </div>
      <div class="dialog-footer ftc" slot="footer">
        <el-button @click="scoreLog.show = false" type="primary">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { clientUserApi } from '@/api/client_user/'
import { formatDate } from './date.js';
export default {
  data() {
    return {
      options: {},
      detail: {},
      pet: {
        list: [],
      },
      searchLog: {
        list: [],
        page: {
          currentPage: 1,
          pageSize: 50,
          total: 0,
        },
      },
      scoreLog: {
        list: [],
        page: {
          currentPage: 1,
          pageSize: 50,
          total: 0,
        },
        ac_id: null,
        show: false,
      },
      remark: {
        ac_id: '',
        score: '',
        reason: '',
        show: false,
      },
      ac_id: '',
      showDisablePop: false,
    }
  },
  filters: {
    filterGender: function(value) {
      switch (value) {
        case 1:
          return '男'
        case 2:
          return '女'
        default:
          return '未知'
      }
    },
    formatDate(time) {
      let date = new Date(time*1000);
      return formatDate(date, 'yyyy-MM');
    }
  },
  created() {
    this.ac_id = this.$route.params.ac_id
    this.getDetail()
    this.getPetList()
    this.getSearchLog()
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      const params = {
        ac_id: this.ac_id,
      }
      return this.$EpetJs.Common.get(clientUserApi.getUserDetail + this.ac_id, params, {
        needLoading: true,
      }).then((res) => {
        if (res) {
          this.detail = res.data.data
        }
        return res
      })
    },
    /**跳转贴纸详情 */
    toCodeDetail(id) {
      this.$router.push('/sticker/detail/' + id)
    },
    /**
     * 获取宠物列表
     */
    getPetList() {
      const params = {
        ac_id: this.ac_id,
      }
      return this.$EpetJs.Common.get(clientUserApi.getPetList + this.ac_id + '/pet', params, {
        needLoading: true,
      }).then((res) => {
        if (res) {
          this.pet.list = res.data.data
        }
        return res
      })
    },
    /**
     * 获取查询日志列表
     */
    getSearchLog(page) {
      const params = {
        page,
        per_page: this.searchLog.page.pageSize,
        ac_id: this.ac_id,
      }
      return this.$EpetJs.Common.get(clientUserApi.getSearchLog + this.ac_id, params, {
        needLoading: true,
      }).then((res) => {
        if (res) {
          this.searchLog.list = res.data.data
          if (res.data.meta && res.data.meta.pagination) {
            this.searchLog.page.total = res.data.meta.pagination.total
            this.searchLog.page.currentPage = res.data.meta.pagination.current_page
          }
        }
        return res
      })
    },
    /**
     * 查询记录翻页
     */
    onChangePage(val) {
      this.getSearchLog(val)
    },

    /**改变用户状态 */
    async onChangeUserStatus() {
      const ac_id = this.ac_id
      const status = this.detail.status
      let url
      if (status == 1) {
        url = clientUserApi.enableStatus + ac_id
      } else if (status == 2) {
        url = clientUserApi.disableStatus + ac_id
      }
      await this.$EpetJs.Common.patch(url, {}, { needLoading: true }).then((res) => {
        console.log(res)
      })
      await this.getDetail()
    },
    /**
     * 积分变动记录 dialog
     */
    async showScoreLog(ac_id, page) {
      this.scoreLog.ac_id = ac_id
      await this.getScoreLog(page)
      this.scoreLog.show = true
    },
    getScoreLog(page = 1) {
      const params = {
        page,
        per_page: this.scoreLog.page.pageSize,
        ac_id: this.scoreLog.ac_id,
      }
      return this.$EpetJs.Common.get(
        clientUserApi.getScoreLog + this.scoreLog.ac_id + '/score/log',
        params,
        {
          needLoading: true,
        },
      ).then((res) => {
        if (res) {
          this.scoreLog.list = res.data.data
          if (res.data.meta && res.data.meta.pagination) {
            this.scoreLog.page.total = res.data.meta.pagination.total
            this.scoreLog.page.currentPage = res.data.meta.pagination.current_page
          }
        }
        return res
      })
    },
    /**
     * 积分记录列表翻页
     */
    onChangescoreLogPage(val) {
      this.getScoreLog(val)
    },

    /**
     * 修改积分
     */
    showRemark(ac_id) {
      this.remark = {
        show: true,
        ac_id,
        reason: '',
        score: '',
      }
      this.$nextTick(() => {
        this.$refs['remarkForm'].clearValidate()
      })
    },
    /**
     * 提交积分修改
     */
    async onRemark() {
      return this.$refs['remarkForm'].validate(async (valid) => {
        if (!valid) return
        const params = {
          reason: this.remark.reason,
          score: this.remark.score,
          ac_id: this.remark.ac_id,
        }
        await this.$EpetJs.Common.patch(clientUserApi.editScore + this.remark.ac_id, params, {
          needLoading: true,
        }).then((res) => {
          console.log(res)
        })
        await this.getDetail()
        this.remark.show = false
      })
    },
  },
}
</script>
<style lang="less">
.list-wrap {
  .list-body {
    min-height: calc(100vh - 60px);
    .delete-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
    .detail-icon {
      color: #000;
      font-size: 20px;
      vertical-align: middle;
    }
  }
}
.table {
  border-collapse: collapse;
  border-spacing: 0;
  color: inherit;
  width: 100%;
  td {
    border: 1px solid #ebeef5;
    color: #606266;
    padding: 6px 10px;
    min-width: 0;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: left;
    font-size: 14px;
  }
}
.avatar {
  width: 60px;
  height: 60px;
}
</style>